var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" Hier kannst du den aktuellen Live-Spielstand sehen. ")]),_c('LiveRankComponent',{attrs:{"gameDbName":_vm.gameDbName}}),_c('br'),_c('v-btn',{attrs:{"to":"/buildings","text":"","color":"primary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.mdiChevronLeft)+" ")]),_vm._v(" Zurück ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }